import _includes from 'lodash/includes';
import SUBSCRIPTION_STATUS from '@achievable-me/tundra-wizard/subscriptionStatus';
import { hasFullAccess } from '@achievable-me/tundra-wizard/auth';
import moment from 'moment';
import storage from '$lib/storage';
import { isBot } from '$lib/userAgent';

const LIMITS = {
  'finra-sie': {
    AUTHENTICATED_MONTHLY_LIMIT: 10,
    UNAUTHENTICATED_MONTHLY_LIMIT: 5,
  },
  'finra-series-7': {
    AUTHENTICATED_MONTHLY_LIMIT: 10,
    UNAUTHENTICATED_MONTHLY_LIMIT: 5,
  },
  gre: {
    AUTHENTICATED_MONTHLY_LIMIT: 4,
    UNAUTHENTICATED_MONTHLY_LIMIT: 2,
  },
  default: {
    AUTHENTICATED_MONTHLY_LIMIT: 6,
    UNAUTHENTICATED_MONTHLY_LIMIT: 3,
  },
};

export const checkAccess = ({ content, product, user }) => {
  const { availability, uuid: contentUuid } = content;
  const { slug } = product;

  const isMetered = !(
    availability === SUBSCRIPTION_STATUS.free ||
    hasFullAccess({ user, product }) ||
    isBot()
  );

  const monthKey = moment().format('YYYYMM');
  const meteredContent = storage.meteredContent.get();
  const meteredContentMonth = meteredContent[monthKey] || [];
  const productLimit = LIMITS[slug] || LIMITS.default;
  const { AUTHENTICATED_MONTHLY_LIMIT, UNAUTHENTICATED_MONTHLY_LIMIT } = productLimit;
  const limit = user ? AUTHENTICATED_MONTHLY_LIMIT : UNAUTHENTICATED_MONTHLY_LIMIT;

  let canView = !isMetered;

  if (isMetered) {
    if (_includes(meteredContentMonth, contentUuid)) {
      canView = true;
    } else if (meteredContentMonth.length < limit) {
      meteredContentMonth.push(contentUuid);
      meteredContent[monthKey] = meteredContentMonth;
      storage.meteredContent.set(meteredContent);
      canView = true;
    }
  }

  const contentRemaining = Math.max(limit - meteredContentMonth.length, 0);

  return {
    canView,
    contentRemaining,
    isMetered,
  };
};
